import { metaDashBoard, Aditional, addLayoutToRoute } from './base_route'

const routes = [
    {
      path: '/dashboard',
      name: 'Dashboard',
      meta: metaDashBoard,
      // route level code-splitting
      // this generates a separate chunk (dashboard.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard_mia.vue'),
      props: false,
    },
    {
      path: '/my_account',
      name: 'Estado de Cuenta',
      meta: metaDashBoard,
      component: () => import('@/views/my_account.vue'),
      props: true,
    },
    {
      path: '/services',
      name: 'Servicios Contratados',
      meta: metaDashBoard,
      component: () => import('@/views/services.vue'),
      props: true,
    },
    {
      path: '/payment_send',
      name: 'Portal de Pago',
      meta: metaDashBoard,
      component: () => import('@/views/Netplus/paymentMenu.vue'),
      props: true,
    },
    {
      path: '/payment',
      name: 'Listado de Pago',
      meta: metaDashBoard,
      component: () => import('@/views/Netplus/payment.vue'),
      props: true,
    },
    {
      path: '/invoices',
      name: 'Facturas',
      meta: metaDashBoard,
      component: () => import('@/views/Netplus/invoices.vue'),
      props: true,
    },
    {
      path: '/tickets',
      name: 'Ticket Generados',
      meta: metaDashBoard,
      component: () => import('@/views/my_tickets.vue'),
      props: true,
    },
    {
      path: '/iptv',
      name: 'Menu Iptv',
      meta: metaDashBoard,
      component: () => import('@/views/iptv.vue'),
      props: true,
    },
    {
      path: '/helpdesk',
      name: 'Ayuda de Sistema',
      meta: metaDashBoard,
      component: () => import('@/views/helpdesk.vue'),
      props: true,
    },
];

const router_client =  routes.map((route) => addLayoutToRoute(route))  

export { router_client }; 
  